import styled, { AnyStyledComponent, css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'
import { CalendarIcon, GuestsIcon, LocationPinIcon } from '../../../../common/icons'

export const MobileSearchBarContainer = styled.div(
    ({ theme }) => css`
        background-color: ${theme.colors.tfwWhite};
        z-index: 1;
        position: relative;
        padding-bottom: 0.4375rem;
    `,
)

export const InputsContainer = styled.div(
    ({ theme }) => css`
        margin: 0 ${theme.spacing.small};
    `,
)

export const Row = styled.div(
    ({ theme }) => css`
        display: flex;

        &:first-child > :first-child {
            border-radius: ${theme.typography.border.radius.xLarge} 0 0 0;
        }

        &:first-child > :last-child {
            border-radius: 0 ${theme.typography.border.radius.xLarge} 0 0;
        }

        &:last-child > :first-child {
            border-radius: 0 0 0 ${theme.typography.border.radius.xLarge};
        }

        &:last-child > :last-child {
            border-radius: 0 0 ${theme.typography.border.radius.xLarge} 0;
            border: none;
        }
    `,
)

interface InputProps {
    hasError?: boolean
}

export const Col = styled.div<InputProps>(
    ({ theme, hasError }) => css`
        display: flex;
        align-items: center;
        flex: 1 1 0;
        height: ${theme.layout.fill};
        border: none;
        border-bottom: 0.125rem dotted ${theme.colors.tfwBlackOpacity10};
        position: relative;
        cursor: pointer;

        ${!!hasError &&
        css`
            border-width: ${theme.typography.border.width.xxThin};
            border-color: ${theme.colors.tfwErrorRed};

            & * {
                color: ${theme.colors.tfwErrorRed};
                stroke: ${theme.colors.tfwErrorRed};
            }
        `};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            border: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlackOpacity10};
        }
    `,
)

export const Input = styled.input.attrs({ readOnly: true, 'aria-readonly': false })(
    ({ theme }) => css`
        width: ${theme.layout.fill};
        background-color: transparent;
        font-size: ${theme.typography.font.size.medium};
        line-height: ${theme.typography.font.size.small};
        padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.xxLarge};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        cursor: pointer;
    `,
)

const InputIcon = styled.svg(
    ({ theme }) => css`
        position: absolute;
    `,
)

export const LocationPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: LocationPinIcon })``
export const DatePickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: CalendarIcon })``
export const GuestPickerIcon = styled(InputIcon as AnyStyledComponent).attrs({ as: GuestsIcon })``
